import polyglotI18nProvider from "ra-i18n-polyglot";

const englishMessages = {
  ra: {
    action: {
      add_filter: "Add filter",
      add: "Add",
      back: "Go Back",
      bulk_actions: "1 item selected |||| %{smart_count} items selected",
      cancel: "Cancel",
      clear_input_value: "Clear value",
      clone: "Clone",
      confirm: "Confirm",
      create: "Create",
      create_item: "Create %{item}",
      delete: "Delete",
      edit: "Edit",
      export: "Export",
      list: "List",
      refresh: "Refresh",
      remove_filter: "Remove this filter",
      remove: "Remove",
      save: "Save",
      search: "Search",
      show: "Show",
      sort: "Sort",
      undo: "Undo",
      unselect: "Unselect",
      expand: "Expand",
      close: "Close",
      open_menu: "Open menu",
      close_menu: "Close menu",
      update: "Update",
      ok: "OK",
      submit: "Submit",
    },
    boolean: {
      true: "Yes",
      false: "No",
      null: " ",
    },
    page: {
      create: "Create %{name}",
      dashboard: "Dashboard",
      edit: "%{name} #%{id}",
      error: "Something went wrong",
      list: "%{name}",
      loading: "Loading",
      not_found: "Not Found",
      show: "%{name} #%{id}",
      empty: "No %{name} yet.",
      invite: "Do you want to add one?",
    },
    input: {
      file: {
        upload_several: "Drop some files to upload, or click to select one.",
        upload_single: "Drop a file to upload, or click to select it.",
      },
      image: {
        upload_several: "Drop some pictures to upload, or click to select one.",
        upload_single: "Drop a picture to upload, or click to select it.",
      },
      references: {
        all_missing: "Unable to find references data.",
        many_missing:
          "At least one of the associated references no longer appears to be available.",
        single_missing:
          "Associated reference no longer appears to be available.",
      },
      password: {
        toggle_visible: "Hide password",
        toggle_hidden: "Show password",
      },
    },
    message: {
      about: "About",
      are_you_sure: "Are you sure?",
      bulk_delete_content:
        "Are you sure you want to delete this %{name}? |||| Are you sure you want to delete these %{smart_count} items?",
      bulk_delete_title: "Delete %{name} |||| Delete %{smart_count} %{name}",
      bulk_update_content:
        "Are you sure you want to update this %{name}? |||| Are you sure you want to update these %{smart_count} items?",
      bulk_update_title: "Update %{name} |||| Update %{smart_count} %{name}",
      delete_content: "Are you sure you want to delete this item?",
      delete_title: "Delete %{name} #%{id}",
      details: "Details",
      error: "A client error occurred and your request couldn't be completed.",
      invalid_form: "The form is not valid. Please check for errors",
      loading: "The page is loading, just a moment please",
      no: "No",
      not_found: "Either you typed a wrong URL, or you followed a bad link.",
      yes: "Yes",
      unsaved_changes:
        "Some of your changes weren't saved. Are you sure you want to ignore them?",
    },
    navigation: {
      no_results: "No results found",
      no_more_results:
        "The page number %{page} is out of boundaries. Try the previous page.",
      page_out_of_boundaries: "Page number %{page} out of boundaries",
      page_out_from_end: "Cannot go after last page",
      page_out_from_begin: "Cannot go before page 1",
      page_range_info: "%{offsetBegin}-%{offsetEnd} of %{total}",
      page_rows_per_page: "รายการต่อหน้า:",
      next: "ถัดไป",
      prev: "ก่อนหน้า",
      skip_nav: "Skip to content",
    },
    sort: {
      sort_by: "Sort by %{field} %{order}",
      ASC: "ascending",
      DESC: "descending",
    },
    auth: {
      auth_check_error: "Please login to continue",
      user_menu: "Profile",
      username: "Username",
      password: "Password",
      sign_in: "Sign in",
      sign_in_error: "Authentication failed, please retry",
      logout: "Logout",
    },
    notification: {
      updated: "Data updated",
      created: "Data created",
      deleted: "Data deleted",
      bad_item: "Incorrect element",
      item_doesnt_exist: "Element does not exist",
      http_error: "Server communication error",
      data_provider_error: "dataProvider error. Check the console for details.",
      i18n_error: "Cannot load the translations for the specified language",
      canceled: "Action cancelled",
      logged_out: "Your session has ended, please reconnect.",
    },
    validation: {
      required: "Required",
      minLength: "Must be %{min} characters at least",
      maxLength: "Must be %{max} characters or less",
      minValue: "Must be at least %{min}",
      maxValue: "Must be %{max} or less",
      number: "Must be a number",
      email: "Must be a valid email",
      oneOf: "Must be one of: %{options}",
      regex: "Must match a specific format (regexp): %{pattern}",
    },
    text: {
      delivery_cost: "Delivery Cost",
      aiRecommendation: "AI Recommendation (beta)",
      branch: "Branch",
      noProducts: "No Products found",
      select: "Select",
      search: "Search",
      search_products: "Search products",
      receiptTitle: "Receipt",
      Transactions: "Transactions",
      General_information: "General information",
      personasandInformation: "Personas & Lifestyle",
      proceed: "Proceed",
      skip: "Skip",
      done: "Done",
      gender: "Gender",
      other: "Other",
      Male: "Male",
      Female: "Female",
      single: "Single",
      married: "Married",
      description: "Description",
      tier: "Tier",
      discount: "Discount",
      offer: "Offer",
      amount: "Amount",
      code: "Code",
      complete: "Complete",
      paymentTitle: "Payment",
      paymentTransferTitle: "PAY",
      ciTitle: "Customer Insight",
      biTitle: "Business Insight",
      points: "points",
      pointasCash: "Point as Cash",
      specialOffers: "Special Offers",
      remaining: "remaining",
      view: "View",
      age: "age",
      qty: "QTY",
      current: "Current",
      note: "Note",
      settingsTitle: "Management",
      pointasCashWalletTitle: "Point as Cash History",
      warningTitle: "Warning",
      doesnotMeetCondition: "Does not meet condition.",
      wrongAuthorizeCode: "The code is wrong",
      pleaseSelectBranch: "Please select branch",
      selectBranch: "Select Branch",
      canUseOnlyOneDiscount: "Only use 1 discount per bill",
      canUseOnlyOneOffer: "Only use 1 offer per bill",
      dontContainSpecialCharacter: "Remove special character",
      phoneNotValid: "Phone is not valid",
      emailNotValid: "Email is not valid",
      birthdateNotValid: "Birthdate is not valid",
      genderRequired: "Gender is required",
      fieldRequired: "This field is required",
      purchasedBy: "Purchased by",
      items: "item(s)",
      enterYourPoints: "Enter your points",
      profileBar: {
        transactions: "transactions",
        quantities: "Quantities",
        months: "Months",
        lifeTimeValueTHB: "Life Time Value (THB)",
        latest: "Latest",
        frequence: "Frequence",
        expensive: "Expensive",
        days: "Days",
        years: "Years",
      },
      payment: {
        member: "Member",
        walkIn: "Walk-in",
        register: "Register",
        selectMemberType: "Select member type",
      },
      memberSearch: {
        findMember: "Find member to get benefit",
        searchMember: "Search member's name or phone number",
        selectaMember: "Select a member",
        weCantFind: "We cannot find this name.Please try again..",
        couldNotFind: "Could not find the member? Register for new member",
        proceedWithNonMember: "Proceed with non-member",
      },
      walkinInfo: {
        walkInInformation: "Walk-in Information",
        hashtag: "#Hashtag",
        addHashtag: "Add hashtag",
        hashtagExample:
          "#Hashtags (Example: good customer, loyalty, kind, ใจดี)",
        placeholder: "good customer, loyalty, kind",
      },
      inputInformation: {
        customerInformation: "Customer Information",
        personasInformation: "Personal Information",
        fullName: "Fullname",
        firstname: "Firstname",
        lastname: "Lastname",
        nickname: "Nickname",
        phoneNumber: "Phone",
        emailAddress: "Email",
        birthday: "Birthdate",
        martialStatus: "Status",
        address: "Address",
        gender: "Gender",
        addressHint: "Address ( building number, road )",
        province: "Province",
        district: "District",
        subDistrict: "Sub-district",
        postcode: "Post code",
        nationality: "Nationality",
        occupation: "Occupation",
        dateCreated: "Date created",
        referralCode: "Referral Code",
        customerInfoSummary: "Customer Information Summary",
      },
      walkinQR: {
        scanQRCode: "แสกน QR Code",
        askCustomer: "Ask customer to scan QR Code to fill the form",
        fillCustomer: "Fill customer's phone number to send the form",
      },
      registerSuccess: {
        congratulation: "Congratulations!",
        yourAccountCreated: "Your account has been created",
        backtoHome: "Back to Home",
        addPayment: "Add payment",
      },
      paymentConfirmation: {
        paymentConfirmation: "Payment Confirmation",
      },
      addProduct: {
        all: "All",
        product: "Product",
        service: "Service",
        package: "Package",
        searchProducts: "Search products",
        orderinBasket: "Order in Basket",
        productName: "Product name",
        clearAll: "Clear all",
        addtoBasket: "Add to Basket",
        total: "Total",
        pointtobeEarned: "Point(s) to be earned",
        applyDiscount: "Apply Discount",
        youhavePoint: "You have points in the wallet",
        applySpecialOffer: "Apply Special Offer",
        confirmtoPay: "Confirm to Pay",
        applyPoint: "Apply Points",
        areYouSure: "Are you sure you want to clear selected products?",
      },
      receipt: {
        subtotal: "Subtotal",
        discount: "Discount",
        purchasedBy: "Purchase by",
        depositPayment: "Deposit payment",
        remainingPoint: "Remaining Points",
        total: "Total",
      },
      paymentOption: {
        selectPayment: "Select payment",
        fullPayment: "Full payment",
        deposit: "Deposit",
        selectPaymentMethod: "Select payment method",
        splitPayment: "Split payment",
      },
      paymentMethod: {
        paymentType: "Payment Type",
        selectSellerBank: "Select Seller bank",
        transferTo: "Transfer to",
        selectCustomerBank: "Select customer bank",
        attachReceipt: "Attach Receipt",
        selectCardType: "Select card type",
        selectBank: "Select bank",
        customerBankReceipt: "Customer bank receipt",
        uploadReceipt: "Upload",
        attachPhoto: "Attach",
        cash: "Cash",
        card: "Debit / Credit Card",
        transfer: "Transfer",
        split: "Split Payment",
        accountName: "Account name",
        accountNumber: "Account number",
        enterBankName: "Enter Bank Name",
        bankInfo: "Bank Info",
        customerBank: "Customer Bank",
        totalAmount: "Total Amount",
        noChange: "No Change",
        change: "Change",
        enterReceiveMoney: "Enter received money",
        paidbyCash: "Paid by Cash",
        paidbyTransfer: "Paid by Bank Transfer",
        paidbyCard: "Paid by Credit/Debit",
        pay: "Pay",
        noOption: "No Option",
        other: "Other",
      },
      paymentSuccess: {
        yourPaymentwasSuccessful: "Your payment was successful",
        printReceipt: "Print Receipt",
      },
      management: {
        userandRole: "Users & Roles",
        memberTier: "Tiers",
        branches: "Branches",
        categories: "Categories",
        product: "Products",
        paymentMethod: "Payment Method",
        paymentHistory: "Payment History",
        offerandDiscount: "Offer & Discount",
        configuration: "Configuration",
        username: "Username",
        fullname: "Fullname",
        role: "Position",
        phone: "Phone",
        status: "Status",
        lastActivity: "Last activity",
        icon: "icon",
        name: "Name",
        level: "Level",
        moneyRequire: "Money Required",
        active: "Active",
        Inactive: "Inactive",
        created: "Created",
        address: "Address",
        productCode: "Code",
        price: "Price",
        uploadPicture: "Upload picture",
        removePicture: "Remove picture",
        adjust: "Adjust",
        void: "Void",
        offerType: "Offer type",
        earn: "Earn",
        contidion: "Condition",
        authorizationCode: "Authorization Code",
        remark: "Remark",
        earnCashtoPoint: "Earn (Cash to point)",
        redeemPointtoCash: "Redeem (Point to Cash)",
        adjustCode: "Adjust code",
        voidCode: "Void code",
        bigSpender: "Big spender",
        frequentPayment: "Frequent payment",
      },
      bi: {
        moreReport: "See More Report",
        tierStat: {
          tierofCustomer: "Top Tier (Customer)",
          topTier: "Top tier",
          tierRevenue: "Top Tier (Revenue)",
        },
        memberStatistic: {
          statistic: "Statistic",
          bigSpender: "Big Spender",
          frequency: "Frequency",
          transactions: "Transactions",
          revenueTHB: "Revenue (THB)",
        },
        loyalty: {
          loyaltyPoints: "Loyalty Points",
          Redeem: "Redeem",
          totalPoint: "Total point",
          Earn: "Earn",
          Remaining: "Remaining",
          Redeemed: "Redeemed",
        },
        Top5Products: "Top 5 Products",
        payments: "Payments",
        transactions: "Transactions",
        members: "Members",
        walkIn: "Walk-In",
        total: "Total",
        revenue: "Revenue",
        totalRevenue: "Total revenue",
        customer: "Customer",
        totalCustomer: "Total customer",
        tier_customer: "Top Tier (customer)",
        tier_revenue: "Top Tier (Revenue)",
        totalRemaining: "Total remaining",
      },
      ci: {
        selectCustomerType: "Select customer type",
        selectPotentialCustomer: "Select Potential customer",
        member: "Member",
        potential: "Potential",
        profile: "Profile",
        wallet: "Wallet",
        pointAsCash: "Point as Cash",
        dateAndTime: "Date and Time",
        transactions: "Transactions",
        earnPoint: "Earn Point",
        amount: "Amount (THB)",
        paymentMethod: "Payment method",
        adjust: "Adjust",
        addMember: "Add member",
        addPotential: "Add potential  ",
        filter: "Filter",
        tags: "Tags",
        lastActivity: "Last Activity",
        nameandPhoneNumber: "Name and Phone number",
        tier: "Tier",
        ltv: "LTV (THB)",
        generalInformation: {
          age: "Age",
          fullName: "Full Name",
          firstName: "First Name",
          lastName: "Last Name",
          nickName: "Nickname",
          birthday: "Birthday",
          nationality: "Nationality",
          thai: "ไทย",
          other: "อื่น ๆ",
          gender: "Gender",
          status: "Status",
          occupation: "Occupation",
          contact: "Contact",
          phoneNumber: "Phone number",
          email: "E-mail",
          address: "Address",
          memberCode: "Member code",
          referral: "Referral",
          recommendBy: "Recommended by",
          referFriend: "Refer friends",
          personasInformation: "Personal Information",
          workAndEducation: "Work & Education",
          familyAndFriend: "Family & Friends",
        },
        personasLifestyle: {
          memberInformation: "Member Information",
          merchantInfo: "Merchant Info",
          interestAndValues: "Interest and Values",
          hobbies: "Hobbies",
          colours: "Colours",
          fashionBrands: "Fashion Brands",
          shoppingPlace: "Shopping Place",
          onlineShopping: "Online Shopping",
          hangouts: "Hangouts",
          books: "Books",
          movies: "Movies",
        },

        searchMember: "Search member",
      },
      report: {
        price: "Price (THB)",
        phone: "Phone",
        transaction: "Transactions",
        transactionTHB: "Transactions (THB)",
        categoryName: "Category name",
        user: "User",
        remark: "Remark",
        ltv: "LTV (THB)",
        totalLTV: "Total LTV",
        totalLTVTHB: "Total LTV (THB)",
        total: "Total",
        quantity: "Quantity (Units)",
        totalQuantity: "Total Quantity (Units)",
        ranking: "Ranking",
        productName: "Product Name",
        paymentMethod: "Payment Method",
        totalPrice: "Total Price (THB)",
        today: "Today",
        totalRevenue: "Total Revenue (THB)",
        revenueTHB: "Revenue (THB)",
        revenue: "Revenue",
        totalMembers: "Total Members",
        totalWalkin: "Total Walk-in",
        date: "Date",
        name: "Name",
        discount: "Discount",
        cash: "Cash",
        transfer: "Transfer",
        credit: "Credit/Debit",
        totalCash: "Total Cash (THB)",
        totalTransfer: "Total Transfer (THB)",
        totalCredit: "Total Credit/Debit (THB)",
        nameandPaymentID: "Name and Payment ID",
        totalPayment: "Total Payment (THB)",
        totalTransactions: "Total Transactions",
        tier: "Tier",
        currentTier: "Current Tier",
        totalEarn: "Total Earn",
        totalRedeem: "Total Redeem (Points)",
        totalRemaining: "Total Remaining (Points)",
        members: "Members",
        bigSpender: "Big Spender",
        frequent: "Frequent",
        frequentCategory: "Frequent Category",
        frequentProduct: "Frequent Product",
        expensiveCategory: "Expensive Category",
        expensiveProduct: "Expensive Product",
        mostFrequentCategory: "Most Frequent Category",
        mostFrequentProduct: "Most Frequent Product",
        mostExpnsiveCategory: "Most Expensive Category",
        mostExpensiveProduct: "Most Expensive Product",
        totalCustomer: "Total Customers",

        productCode: "Product Code",

        category: "Category",
      },
      forgotPassword: {
        forgotPassword: "Forgot Your Password",
        enterUsernameBelow: "Enter your username below.",
        usernameError:
          "This username does not exist in the system. Please try again.",
        otpError: "OTP do not match. Please try again or Resend OTP.",
        resetPassword: "Reset Password",
        checkYourEmail: "Check your email",
        sentOtp: "We have sent OTP to your email.",
        enterOtpRecvivedVia: "Enter your OTP received via",
        resendOtp: "Resend OTP",
        newPassword: "New password",
        setNewPassword: "Set your new password.",
        newPasswordCondition: "Include at least one of the following:",
        newPasswordMinimum: " 9 characters minimum",
        confirmPassword: "Confirm your new password",
        passwordError: "Passwords do not match, please try again.",
        congratulation: "Congratulations!",
        passwordChanged: "Your password has been changed successfully",
        goToSignIn: "Go to sign-in again",
      },
    },
  },
};
const thaiMessages = {
  ra: {
    action: {
      add_filter: "ใส่ตัวกรอง",
      add: "เพิ่ม",
      back: "ย้อนกลับ",
      bulk_actions: "เลือกไปแล้วหนึ่งชิ้น |||| เลือกไปแล้ว %{smart_count} ชิ้น",
      cancel: "ยกเลิก",
      clear_input_value: "ล้างค่า",
      clone: "คัดลอก",
      confirm: "ยืนยัน",
      create: "สร้าง",
      create_item: "สร้าง %{item}",
      delete: "ลบ",
      edit: "แก้ไข",
      export: "ส่งออก",
      list: "รายการ",
      refresh: "รีเฟรช",
      remove_filter: "ลบตัวกรองนี้",
      remove: "ลบ",
      save: "บันทึก",
      search: "ค้นหา",
      show: "แสดง",
      sort: "เรียง",
      undo: "Undo",
      unselect: "Unselect",
      expand: "ขยาย",
      close: "ปิด",
      open_menu: "เปิดเมนู",
      close_menu: "ปิดเมนู",
      update: "อัพเดท",
      ok: "ตกลง",
      submit: "ยืนยัน",
    },
    boolean: {
      true: "ใช่",
      false: "ไม่",
      null: " ",
    },
    page: {
      create: "สร้าง %{name}",
      dashboard: "แดชบอร์ด",
      edit: "%{name} #%{id}",
      error: "เกิดข้อผิดพลาด",
      list: "%{name}",
      loading: "กำลังโหลด",
      not_found: "ไม่พบ",
      show: "%{name} #%{id}",
      empty: "ไม่มี %{name}",
      invite: "ต้องการเพิ่ม ?",
    },
    input: {
      file: {
        upload_several: "ลากไฟล์วางเพื่ออัพโหลด, หรือคลิกแล้วเลือก",
        upload_single: "ลากไฟล์วางเพื่ออัพโหลด, หรือคลิกแล้วเลือก",
      },
      image: {
        upload_several: "ลากวางรูปเพื่ออัพโหลด หรือคลิกเพื่อเลือก",
        upload_single: "ลากวางรูปเพื่ออัพโหลด หรือคลิกเพื่อเลือก",
      },
      references: {
        all_missing: "ไม่พบข้อมูลที่อ้างถึง",
        many_missing: "อย่างน้อยหนึ่งค่าไม่พบข้อมูลที่อ้างถึง",
        single_missing: "อย่างน้อยหนึ่งค่าไม่พบข้อมูลที่อ้างถึง",
      },
      password: {
        toggle_visible: "ซ่อนรหัสผ่าน",
        toggle_hidden: "แสดงรหัสผ่าน",
      },
    },
    message: {
      about: "เกี่ยวกับ",
      are_you_sure: "แน่ใจหรือไม่?",
      bulk_delete_content:
        "แน่ใจหรือไม่ที่จะลบ %{name}? |||| แน่ใจหรือไม่ที่จะลบ %{smart_count} รายการ?",
      bulk_delete_title: "ลบ %{name} |||| ลบ %{smart_count} %{name}",
      bulk_update_content:
        "Are you sure you want to update this %{name}? |||| Are you sure you want to update these %{smart_count} items?",
      bulk_update_title: "Update %{name} |||| Update %{smart_count} %{name}",
      delete_content: "ต้องการที่จะลบรายการนี้หรือไม่?",
      delete_title: "ลบ %{name} #%{id}",
      details: "รายละเอียด",
      error: "A client error occurred and your request couldn't be completed.",
      invalid_form: "The form is not valid. Please check for errors",
      loading: "กำลังโหลด",
      no: "ไม่",
      not_found: "Either you typed a wrong URL, or you followed a bad link.",
      yes: "ใช่",
      unsaved_changes:
        "Some of your changes weren't saved. Are you sure you want to ignore them?",
    },
    navigation: {
      no_results: "ไม่พบข้อมูล",
      no_more_results:
        "The page number %{page} is out of boundaries. Try the previous page.",
      page_out_of_boundaries: "Page number %{page} out of boundaries",
      page_out_from_end: "Cannot go after last page",
      page_out_from_begin: "Cannot go before page 1",
      page_range_info: "%{offsetBegin}-%{offsetEnd} of %{total}",
      page_rows_per_page: "รายการต่อหน้า:",
      next: "ถัดไป",
      prev: "ก่อนหน้า",
      skip_nav: "Skip to content",
    },
    sort: {
      sort_by: "Sort by %{field} %{order}",
      ASC: "ascending",
      DESC: "descending",
    },
    auth: {
      auth_check_error: "Please login to continue",
      user_menu: "Profile",
      username: "Username",
      password: "รหัสผ่าน",
      sign_in: "เข้าสู่ระบบ",
      sign_in_error: "Authentication failed, please retry",
      logout: "Logout",
    },
    notification: {
      updated: "แก้ไขข้อมูลแล้ว",
      created: "สร้างข้อมูลแล้ว",
      deleted: "ลบข้อมูลแล้ว",
      bad_item: "รายการไม่ถูกต้อง",
      item_doesnt_exist: "ข้อมูลนี้ไม่มีอยู่",
      http_error: "Server communication error",
      data_provider_error: "dataProvider error. Check the console for details.",
      i18n_error: "Cannot load the translations for the specified language",
      canceled: "Action cancelled",
      logged_out: "Your session has ended, please reconnect.",
    },
    validation: {
      required: "ต้องการ",
      minLength: "Must be %{min} characters at least",
      maxLength: "Must be %{max} characters or less",
      minValue: "Must be at least %{min}",
      maxValue: "Must be %{max} or less",
      number: "Must be a number",
      email: "Must be a valid email",
      oneOf: "Must be one of: %{options}",
      regex: "Must match a specific format (regexp): %{pattern}",
    },
    resources: {
      products: {
        name: "สินค้า",
        fields: {
          code: "รหัส",
        },
      },
    },
    text: {
      delivery_cost: "ค่าจัดส่ง",
      aiRecommendation: "แนะนำจาก AI (beta)",
      branch: "สาขา",
      warningTitle: "แจ้งเตือน",
      noProducts: "ไม่มีสินค้าในหมวดนี้",
      select: "เลือก",
      search: "ค้นหา",
      search_products: "ค้นหาสินค้า",
      receiptTitle: "ใบเสร็จ",
      Transactions: "Transactions",
      General_information: "ข้อมูลทั่วไป",
      personasandInformation: "พฤติกรรมและไลฟ์สไตล์",
      proceed: "ดำเนินการต่อ",
      skip: "ข้าม",
      done: "เสร็จสิ้น",
      gender: "เพศ",
      other: "อื่นๆ",
      Male: "ชาย",
      Female: "หญิง",
      single: "โสด",
      married: "แต่งงาน",
      description: "รายละเอียด",
      tier: "ระดับสมาชิก",
      discount: "ส่วนลด",
      offer: "ข้อเสนอ",
      amount: "จำนวนเงิน",
      code: "รหัส",
      complete: "สำเร็จ",
      cancel: "ยกเลิก",
      paymentTitle: "ชำระเงิน",
      paymentTransferTitle: "ชำระเงิน",
      ciTitle: "ข้อมูลของสมาชิก",
      biTitle: "ภาพรวมของธุรกิจเชิงลึก",
      points: "คะแนน",
      pointasCash: "ใช้คะแนนแทนเงินสด",
      specialOffers: "ข้อเสนอพิเศษ",
      remaining: "คงเหลือ",
      view: "ข้อมูล",
      age: "อายุ",
      qty: "จำนวน",
      current: "รวม",
      note: "บันทึก",
      settingsTitle: "ตั้งค่า",
      pointasCashWalletTitle: "ประวัติใช้คะแนนแทนเงินสด",
      doesnotMeetCondition: "ไม่ครบเงื่อนไขการใช้งาน",
      wrongAuthorizeCode: "รหัสไม่ถูกต้อง กรุณาลองใหม่อีกครั้งค่ะ",
      pleaseSelectBranch: "กรุณาเลือกสาขา",
      selectBranch: "เลือกสาขา",
      canUseOnlyOneDiscount: "สามารถใช้ส่วนลดได้แค่ 1 รูปแบบต่อบิล",
      canUseOnlyOneOffer: "สามารถใช้ข้อเสนอได้แค่ 1 รูปแบบต่อบิล",
      dontContainSpecialCharacter: "มีอักษรพิเศษ",
      phoneNotValid: "เบอร์โทรศัพท์ไม่ถูกต้อง",
      emailNotValid: "อีเมลไม่ถูกต้อง",
      birthdateNotValid: "วันเกิดไม่ถูกต้อง",
      genderRequired: "ระบุเพศ",
      fieldRequired: "กรุณาใส่ข้อมูล",
      purchasedBy: "ชำระโดย",
      items: "ชิ้น",
      enterYourPoints: "ระบุคะแนนที่ใช้",
      profileBar: {
        transactions: "รายการ",
        quantities: "จำนวน",
        months: "เดือน",
        lifeTimeValueTHB: "Life Time Value (THB)",
        latest: "ล่าสุด",
        frequence: "บ่อย",
        expensive: "แพง",
        days: "วัน",
        years: "ปี",
      },
      payment: {
        member: "สมาชิก",
        walkIn: "ลูกค้า Walk-in",
        register: "ลงทะเบียน",
        selectMemberType: "เลือกประเภทของลูกค้า",
      },
      memberSearch: {
        findMember: "ค้นหาสมาชิก",
        searchMember: "ชื่อหรือเบอร์โทรศัพท์ของสมาชิก",
        selectaMember: "เลือกสมาชิก",
        weCantFind:
          "ไม่พบชื่อนี้...โปรดค้นหาอีกครั้งด้วยเบอร์โทรศัพท์หรือกดสมัครสมาชิกใหม่",
        couldNotFind: "ไม่พบสมาชิก? สมัครสมาชิกใหม่",
        proceedWithNonMember: "ดำเนินการต่อโดยไม่เป็นสมาชิก",
      },

      walkinInfo: {
        walkInInformation: "ข้อมูลของ Walk-in",
        hashtag: "#แฮชแท็ก",
        addHashtag: "เพิ่มแฮชแท็ก",
        hashtagExample: "#แฮชแท็ก (เช่น: ใจดี, สุภาพ)",
        placeholder: "ใจดี, สุภาพ",
      },
      inputInformation: {
        customerInformation: "ข้อมูลของลูกค้า",
        personasInformation: "ข้อมูลส่วนตัว",
        fullName: "ชื่อและนามสกุล",
        firstname: "ชื่อจริง",
        lastname: "นามสกุล",
        nickname: "ชื่อเล่น",
        phoneNumber: "โทรศัพท์",
        emailAddress: "ที่อยู่อีเมล",
        birthday: "วันเกิด",
        martialStatus: "สถานภาพ",
        address: "ที่อยู่",
        addressHint: "ที่อยู่ ( บ้านเลขที่, ถนน )",
        province: "จังหวัด",
        district: "เขต/อำเภอ",
        subDistrict: "แขวง/ตำบล",
        postcode: "รหัสไปรษณีย์",
        gender: "เพศ",
        nationality: "สัญชาติ",
        occupation: "อาชีพ",
        dateCreated: "สร้างเมื่อวันที่",
        referralCode: "Referral Code",
        customerInfoSummary: "ข้อมูลของลูกค้า",
      },
      walkinQR: {
        scanQRCode: "แสกน QR Code",
        askCustomer:
          "สำหรับลูกค้าที่ต้องการแสกน QR Code เพื่อกรอกแบบฟอร์มด้วยตนเอง",
        fillCustomer: "กรอกหมายเลขโทรศัพท์ของลูกค้าเพื่อทำการส่งแบบฟอร์ม",
      },
      registerSuccess: {
        congratulation: "Congratulations!",
        yourAccountCreated:
          "ดำเนินการลงทะเบียนเสร็จสิ้น Your account has been created",
        backtoHome: "กลับสู่หน้าหลัก",
        addPayment: "เพิ่มรายการชำระเงิน",
      },
      paymentConfirmation: {
        paymentConfirmation: "ยืนยันการชำระเงิน",
      },
      addProduct: {
        all: "ทั้งหมด",
        product: "สินค้า",
        service: "บริการ",
        package: "แพ็กเก็จ",
        searchProducts: "ค้นหาสินค้าหรือบริการ",
        orderinBasket: "สินค้าในตระกร้า",
        productName: "ชื่อสินค้าหรือบริการ",
        clearAll: "ลบทั้งหมด",
        addtoBasket: "เพิ่มสินค้าในตะกร้า",
        total: "ทั้งหมด",
        pointtobeEarned: "คะแนนที่จะได้รับ",
        applyDiscount: "ใช้ส่วนลดนี้",
        applySpecialOffer: "ใช้ข้อเสนอพิเศษนี้",
        applyPoint: "ใช้คะแนน",
        areYouSure: "คุณแน่ใจหรือไม่ว่าต้องการลบสินค้าที่เลือกไว้?",
        youhavePoint: "คุณมีคะแนนอยู่ทั้งหมด",
        confirmtoPay: "ยืนยันการชำระเงิน",
      },
      receipt: {
        subtotal: "ยอดรวม",
        discount: "ส่วนลด",
        purchasedBy: "ชำระด้วย",
        depositPayment: "ชำระมัดจำ",
        remainingPoint: "คะแนนคงเหลือ",
        total: "ยอดรวม",
      },
      paymentOption: {
        selectPayment: "จ่ายบิล",
        fullPayment: "เต็มจำนวน",
        deposit: "มัดจำ",
        selectPaymentMethod: "เลือกวิธีชำระเงิน",
        splitPayment: "จ่ายหลายวิธี",
      },
      paymentMethod: {
        other: "อื่นๆ",
        paymentType: "วิธีการจ่าย",
        selectSellerBank: "เลือกธนาคารของร้านค้า",
        transferTo: "โอนเงินไป",
        selectCustomerBank: "เลือกธนาคารของลูกค้า",
        attachReceipt: "แนบรูปหลักฐานการชำระเงิน",
        selectCardType: "เลือกประเภทบัตร",
        selectBank: "เลือกธนาคาร",
        accountName: "ชื่อบัญชี",
        accountNumber: "หมายเลขบัญชี",
        customerBankReceipt: "หลักฐานการชำระเงิน",
        enterBankName: "เลือกธนาคาร",
        uploadReceipt: "อัพโหลด",
        attachPhoto: "แนปรูป",
        cash: "เงินสด",
        card: "บัตรเครดิต/เดบิต",
        transfer: "โอน",
        split: "จ่ายหลายวิธี",
        bankInfo: "ข้อมูลบัญชี",
        customerBank: "ธนาคารของลูกค้า",
        totalAmount: "ยอดเงินที่ต้องชำระ",
        noChange: "พอดี",
        change: "เงินทอน",
        enterReceiveMoney: "ยอดเงินที่ได้รับ",
        paidbyCash: "จ่ายด้วยเงินสด",
        paidbyTransfer: "จ่ายด้วยการโอน",
        paidbyCard: "จ่ายด้วยบัตรเครดิต",
        pay: "จ่าย",
        noOption: "ไม่มีตัวเลือก",
      },
      paymentSuccess: {
        yourPaymentwasSuccessful: "การชำระเงินของคุณเสร็จสิ้นแล้ว",
        printReceipt: "พิมพ์ใบเสร็จ",
      },
      management: {
        userandRole: "ผู้ใช้งานและสิทธิ",
        memberTier: "ระดับสมาชิก",
        branches: "สาขา",
        categories: "หมวดหมู่สินค้า",
        product: "สินค้า",
        paymentMethod: "ช่องทางการชำระเงิน",
        paymentHistory: "ประวัติของคำสั่งซื้อ",
        offerandDiscount: "สิทธิพิเศษและส่วนลด",
        configuration: "การกำหนดและการตั้งค่าทั่วไป",
        username: "ผู้ใช้งาน",
        fullname: "ชื่อจริง",
        role: "ตำแหน่ง",
        phone: "หมายเลขโทรศัพท์",
        status: "สถานะ",
        lastActivity: "อัพเดทล่าสุด",
        icon: "สัญลักษณ์",
        name: "ชื่อ",
        level: "ระดับ",
        moneyRequire: "เงื่อนไข",
        active: "พร้อมใช้งาน",
        Inactive: "ยังไม่ใช้งาน",
        created: "สร้างเมื่อ",
        address: "ที่อยู่",
        productCode: "รหัสหมวดหมู่สินค้า",
        price: "ราคา",
        uploadPicture: "อัพโหลดรูปภาพ",
        removePicture: "ลบรูปภาพ",
        adjust: "แก้ไขบิล",
        void: "ยกเลิกบิล",
        offerType: "ประเภท",
        earn: "สะสมคะแนน",
        contidion: "เงื่อนไข",
        authorizationCode: "รหัสอนุญาต",
        remark: "ข้อสังเกต",
        earnCashtoPoint: "การสะสม (กี่บาทได้กี่คะแนน) Earn (Cash to point)",
        redeemPointtoCash: "การแลก (กี่คะแนนเป็นกี่บาท) Redeem (Point to Cash)",
        adjustCode: "รหัสอนุญาตให้แก้ไขบิล",
        voidCode: "รหัสอนุญาตให้ยกเลิกบิล",
        bigSpender: "ยอดใช้จ่ายสะสม",
        frequentPayment: "จำนวนครั้งการซื้อขั้นต่ำ",
      },
      bi: {
        moreReport: "ดูรายงานเพิ่มเติม",
        tierStat: {
          tierofCustomer: "ระดับสมาชิกสูงสุด (ลูกค้า)",
          tierRevenue: "ระดับสมาชิก(รายได้)",
          topTier: "ระดับสมาชิกสูงสุด",
        },
        memberStatistic: {
          statistic: "สถิติสมาชิก",
          bigSpender: "กลุ่มลูกค้าที่กำลังซื้อสูง",
          frequency: "กลุ่มลูกค้าประจำ",
          transactions: "ประวัติการสั่งซื้อ",
          revenueTHB: "รายได้ (บาท)",
        },
        loyalty: {
          loyaltyPoints: "คะแนนความภักดีลูกค้า",
          Redeem: "แลก",
          totalPoint: "คะแนนทั้งหมด",
          Earn: "สะสม",
          Remaining: "คงเหลือ",
          Redeemed: "อัตราการแลกคะแนน",
        },
        Top5Products: "5 อันดับสินค้ายอดนิยม",
        payments: "ช่องทางการชำระเงิน",
        transactions: "ประวัติการสั่งซื้อ",
        members: "ลูกค้าที่เป็นสมาชิก",
        walkIn: "ลูกค้า Walk-in",
        total: "ทั้งหมด",
        revenue: "ยอดขาย",
        totalRevenue: "ยอดขายทั้งหมด",
        customer: "ลูกค้า",
        totalCustomer: "ลูกค้าทั้งหมด",
        tier_customer: "ระดับสมาชิกสูงสุด (จำนวนลูกค้า)",
        tier_revenue: "ระดับสมาชิกสูงสุด (จำนวนเงิน)",
        totalRemaining: "คะแนนคงเหลือ",
      },
      ci: {
        selectCustomerType: "เลือกประเภทลูกค้า",
        selectPotentialCustomer: "เลือกลูกค้าที่ไม่ได้เป็นสมาชิก",
        member: "สมาชิก",
        potential: "ลูกค้าที่ไม่ได้เป็นสมาชิก",
        profile: "โปรไฟล์",
        wallet: "วอลเล็ต",
        transactions: "ประวัติการสั่งซื้อ",
        pointAsCash: "การสะสมและแลกคะแนน",
        dateAndTime: "วันและเวลา",
        earnPoint: "สะสมคะแนน",
        amount: "ยอดทั้งหมด (บาท)",
        paymentMethod: "ช่องทางการชำระเงิน",
        adjust: "ปรับปรุงรายการ",
        addMember: "เพิ่มสมาชิก",
        addPotential: "เพิ่มลูกค้าที่ไม่ได้เป็นสมาชิก",
        filter: "ตัวกรอง",
        tags: "แท็ก",
        lastActivity: "กิจกรรมล่าสุด",
        nameandPhoneNumber: "ชื่อและเบอร์โทรศัพท์",
        tier: "ระดับสมาชิก",
        ltv: "LTV (THB)",
        generalInformation: {
          age: "อายุ",
          fullName: "ชื่อและนามสกุล",
          firstName: "ชื่อ",
          lastName: "นามสกุล",
          nickName: "ชื่อเล่น",
          birthday: "วันเกิด",
          nationality: "เชื้อชาติ",
          thai: "ไทย",
          other: "อื่น ๆ",
          gender: "เพศ",
          status: "สถานะ",
          occupation: "อาชีพ",
          contact: "ข้อมูลติดต่อ",
          phoneNumber: "โทรศัพท์",
          email: "อีเมล",
          address: "ที่อยู่",
          memberCode: "รหัสสมาชิก",
          referral: "ข้อมูลผู้แนะนำ",
          recommendBy: "แนะนำโดย",
          referFriend: "ผู้แนะนำ",
          personasInformation: "ข้อมูลส่วนตัว",
          workAndEducation: "ข้อมูลการศึกษาและการทำงาน",
          familyAndFriend: "ข้อมูลเกี่ยวกับครอบครัวและเพื่อน",
        },
        personasLifestyle: {
          memberInformation: "ข้อมูลสมาชิก",
          merchantInfo: "ข้อมูลของกลุ่มเป้าหมาย",
          interestAndValues: "ความสนใจ",
          hobbies: "งานอดิเรก",
          colours: "สีที่ชอบ",
          fashionBrands: "แบรนด์ที่ชอบ",
          shoppingPlace: "ห้างสรรพสินค้าที่ชอบ",
          onlineShopping: "แหล่งซื้อของออนไลน์",
          hangouts: "ร้านที่ชอบ",
          books: "หนังสือที่ชอบ",
          movies: "ภาพยนตร์ที่ชอบ",
        },

        searchMember: "ค้นหาสมาชิก",
      },
      report: {
        price: "ราคา (THB)",
        phone: "หมายเลขโทรศัพท์",
        transaction: "ประวัติการสั่งซื้อ",
        transactionTHB: "ประวัติการสั่งซื้อ (บาท)",
        categoryName: "ชื่อหมวดหมู่",
        ltv: "LTV (บาท)",
        totalLTV: "รวม LTV",
        totalLTVTHB: "รวม LTV (บาท)",
        total: "รวม",
        user: "พนักงาน",
        remark: "หมายเหตุ",
        quantity: "รวมสินค้า (ชิ้น)",
        totalQuantity: "รวมสินค้า (ชิ้น)",
        ranking: "อันดับ",
        productName: "ชื่อสินค้า",
        paymentMethod: "ช่องทางการชำระเงิน",
        totalPrice: "ราคารวม (บาท)",
        today: "วันนี้",
        revenue: "ยอดขาย",
        revenueTHB: "ยอดขาย (บาท)",
        totalRevenue: "รวมรายได้ (บาท)",
        totalMembers: "รวมสมาชิก",
        totalWalkin: "รวมลูกค้าหน้าร้าน",
        date: "วันที่",
        name: "ชื่อ",
        discount: "ส่วนลด",
        cash: "เงินสด",
        transfer: "โอน",
        credit: "บัตรเครดิต/บัตรเดบิต",
        totalCash: "รายได้ (เงินสด)",
        totalTransfer: "รวมรายได้โอน(บาท)",
        totalCredit: "รวมรายได้ (บัตรเครดิต/เดบิต)",
        nameandPaymentID: "ชื่อและหมายเลขคำสั่งซื้อ",
        totalPayment: "รวมการชำระเงิน (บาท)",
        totalTransactions: "รวมยอดคำสั่งซื้อ",
        tier: "ระดับสมาชิก",
        currentTier: "ระดับสมาชิกปัจจุบัน",
        totalEarn: "คะแนนที่สะสมทั้งหมด",
        totalRedeem: "คะแนนที่แลกทั้งหมด",
        totalRemaining: "Total Remaining (Points)",
        members: "สมาชิก",
        bigSpender: "กลุ่มลูกค้าที่กำลังซื้อสูง",
        frequent: "จำนวนครั้ง",
        frequentCategory: "หมวดหมู่ยอดนิยม",
        frequentProduct: "สินค้ายอดนิยม",
        expensiveCategory: "หมวดหมู่ที่มูลค่าสูง",
        expensiveProduct: "สินค้าที่มูลค่าสูง",
        mostFrequentCategory: "หมวดหมู่ยอดนิยมที่สุด",
        mostFrequentProduct: "สินค้ายอดนิยมที่สุด",
        mostExpnsiveCategory: "หมวดหมู่ที่มูลค่าสูงที่สุด",
        mostExpensiveProduct: "สินค้าที่มูลค่าสูงที่สุด",
        totalCustomer: "รวมลูกค้า",

        productCode: "รหัสสินค้า",

        category: "หมวดหมู่",
      },
      forgotPassword: {
        forgotPassword: "Forgot Your Password",
        enterUsernameBelow: "Enter your username below.",
        usernameError:
          "This username does not exist in the system. Please try again.",
        otpError: "OTP do not match. Please try again or Resend OTP.",
        resetPassword: "Reset Password",
        checkYourEmail: "Check your email",
        sentOtp: "We have sent OTP to your email.",
        enterOtpRecvivedVia: "Enter your OTP received via",
        resendOtp: "Resend OTP",
        newPassword: "New password",
        setNewPassword: "Set your new password.",
        newPasswordCondition: "Include at least one of the following:",
        newPasswordMinimum: " 9 characters minimum",
        confirmPassword: "Confirm your new password",
        passwordError: "Passwords do not match, please try again.",
        congratulation: "Congratulations!",
        passwordChanged: "Your password has been changed successfully",
        goToSignIn: "Go to sign-in again",
      },
    },
  },
};

const i18nProvider = polyglotI18nProvider(
  (locale) => (locale === "th" ? thaiMessages : englishMessages),
  "th" // Default locale
);
export default i18nProvider;
